import {
	TResponseItemWrapper,
	TResponseListWrapper,
} from '../../common/types/common';
import { TJob, TJobDetails } from '../../common/types/job';
import { apiClient, getCurrentUserEmail } from '../apiClient';

export const getAllJobs = async (): Promise<TResponseListWrapper<TJob>> => {
	return apiClient.get('/Job/GetAllJobs');
};

export const getJobList = async ({
	pagination: { pageSize, pageIndex },
	sorting: { sortBy, isDescending },
	filtering: { searchTerm },
}) => {
	let sorting = sortBy ? `&sortBy=${encodeURIComponent(sortBy)}` : '';
	if (sortBy && isDescending) {
		sorting += `&isDescending=${encodeURIComponent(isDescending)}`;
	}

	const search = searchTerm
		? `&searchTerm=${encodeURIComponent(searchTerm)}`
		: '';

	return apiClient.get(
		`/Job/GetJobs?pageSize=${encodeURIComponent(
			pageSize,
		)}&pageNumber=${encodeURIComponent(pageIndex)}${sorting}${search}`,
	);
};

export const getJobListForUser = async ({
	pagination: { pageSize, pageIndex },
	sorting: { sortBy, isDescending },
	filtering: { searchTerm },
}) => {
	let sorting = sortBy ? `&sortBy=${encodeURIComponent(sortBy)}` : '';
	if (sortBy && isDescending) {
		sorting += `&isDescending=${encodeURIComponent(isDescending)}`;
	}

	const search = searchTerm
		? `&searchTerm=${encodeURIComponent(searchTerm)}`
		: '';

	// FEATURE FLAG: AuthRequired bypass — include userEmail param so the API can resolve the user
	// when auth enforcement is off and no JWT email claim is present.
	const email = getCurrentUserEmail();
	const userEmailParam = email ? `&userEmail=${encodeURIComponent(email)}` : '';

	return apiClient.get(
		`/Job/GetJobsForUser?pageSize=${encodeURIComponent(
			pageSize,
		)}&pageNumber=${encodeURIComponent(pageIndex)}${sorting}${search}${userEmailParam}`,
	);
};

export const getJob = async (
	jobId,
): Promise<TResponseItemWrapper<TJobDetails>> => {
	return apiClient.get(`/Job/GetJob?jobId=${encodeURIComponent(jobId)}`);
};

export const deleteJob = async (jobId) => {
	return apiClient.delete(`/Job/DeleteJob?jobId=${encodeURIComponent(jobId)}`);
};

export const createJob = async (job) => {
	return apiClient.post('/Job/CreateJob', job);
};

export const updateJobStatus = async (data) => {
	return apiClient.post('/Job/UpdateStatus', data);
};

export const completeJob = async (jobId: number) => {
	return apiClient.post(`/Job/CompleteJob?jobId=${encodeURIComponent(jobId)}`);
};

export const updateJob = async (data) => {
	return apiClient.post('/Job/UpdateJob', data);
};
